<i class="justify-content-center ri-message-3-line display-3 text-primary-emphasis d-flex"></i>
<h2 class="justify-content-center h3 d-flex py-2 text-primary-emphasis">{{ message }}</h2>

@if(subMessage) {
  <h5 class="justify-content-center h5 d-flex py-2 text-muted">{{ subMessage }}</h5>
}

@if(labelButton) {
  <button
    class="btn btn-primary"
    [ngClass]="buttonClass"
    (click)="emit()"
  >
    {{ labelButton }}
  </button>
}